import React from 'react';
import './HelpModal.css';

/**
 * Componente de Modal de Ajuda
 * @param {Object} props - Propriedades do componente
 * @param {boolean} props.isOpen - Se o modal está aberto
 * @param {Function} props.onClose - Função para fechar o modal
 * @param {string} props.title - Título do modal
 * @param {ReactNode} props.children - Conteúdo do modal
 * @param {string} props.icon - Ícone para o título (opcional)
 */
const HelpModal = ({ isOpen, onClose, title, children, icon }) => {
  if (!isOpen) return null;
  
  // Handle click outside modal
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="help-modal-overlay"
      onClick={handleOverlayClick}
      aria-modal="true" 
      role="dialog"
    >
      <div className="help-modal">
        <div className="help-modal-header">
          <h2 className="help-modal-title">
            {icon && <span className="help-modal-icon">{icon}</span>}
            {title}
          </h2>
          <button 
            className="help-modal-close-button" 
            onClick={onClose}
            aria-label="Fechar modal de ajuda"
          >
            &times;
          </button>
        </div>
        <div className="help-modal-content">
          {children}
        </div>
        <div className="help-modal-footer">
          <button 
            className="help-modal-button" 
            onClick={onClose}
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

export default HelpModal;
